function ZstValidation() {
    /// <summary>
    /// This object provides common functions for the Widget.DataCenter.ZstValidation.vb <br/>
    /// Author: GWA<br />
    /// Date: 17.10.2019<br />
    /// Copyright ©: EUDT GmbH 2019 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 17.10.2019                                              *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.bInit = false;
    
}
ZstValidation.prototype = new vcTemplate();


//table: {
//    header: {
//        signal: "Signal",
//        date: "Datum",
//        sum: "Summe",
//        diff: "Differenz zu Zählermessungen",
//        diffZst: "Differenz zwischen Zählermessungen"
//    }
//}


ZstValidation.prototype.isVcDateInit = true;

ZstValidation.prototype.init = function () {
    /// <summary>
    /// This function inits the Visual
    /// </summary>
    var me = this;
    var h;
    try {
        if (me.error) { return false; }
        var param = { "Type": 2 }
        var visualHeight = me.height;
        var menueHeight = 0;
        var tableHeaderHeight = me.visual.find(".content .vc-list-header").height();

        me.visual.find(".menue .vc-date-box").vcDateBox({
            mode: "Range",
            align: "right",
            interval: 1,
            defaultRange: { from: moment(me.startdate, "DD.MM.YYYY").subtract(7, 'days').toDate(), to: me.startdate },
            langID: me.settings.userLangIDForCulture,
            callback: function() { me.fillTable() }
        }); 

        me.visual.find(".menue .vc-filter-box").vcOptionBox({
            caption: me.visualData.Resources.filterBoxCaption,
            items: [{ button: me.visualData.Resources.filterBoxButton, clickable: false, isList: false, content: $("<div>").addClass("vc-filter")[0].outerHTML }]
        });

        me.visual.find(".menue .vc-filter").vcFilter({ callback: function () { me.filter() } });

        menueHeight = me.visual.find(".menue .vc-date-box").height();
        me.visual.find(".menue .vc-filter.box").height(menueHeight);
        me.visual.find(".menue").height(menueHeight);
        me.visual.find(".vc-list-table").css("max-height", visualHeight - menueHeight - tableHeaderHeight);

        return true;
    } catch (ex) { me.writeError('init', ex); return false; }
};

ZstValidation.prototype.fillTable = function () {
    /// <summary>
    /// This function inits the Visual
    /// </summary>
    var me = this;
    var dateRange = null;
    var h;
    try {
        if (me.error) { return false; }
        me.visual.find("> .content .vc-list-table").html(me.vcC.getLoadingIcon());
        
        dateRange = me.visual.find(".vc-date-box").vcDateBox("getDateRange");
        var getParam = { "Type": 1, "Bsaid": 10870, "StartDate": dateRange.from, "EndDate": dateRange.to }
        
        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, JSON.stringify({"LoggerId": me.LoggerId}), '', me.deviceType, me.langid, JSON.stringify(getParam), function (result) {
            if (result == null) {
                alert(me.visualData.Resources.err_loadData);
                return false;
            }

            var vcListTable = $("<ul>").addClass("vc-list-table"); 
                var vcListItem = $("<li>").addClass("vc-list-item");
                    var vcListCol = $("<div>").addClass("vc-list-col");
                        var vcListColElement = $("<div>").addClass("vc-list-col-element");

            var table = vcListTable.clone();
            var tableRow = null;
            var i = 1;
            var sum;
            var diff;
            var zstDiff;

            

            result.forEach(function (el) {
                sum =  me.formatNumber(String(el.Sum).replace(".", ","), 4);
                diff = me.formatNumber(String(el.Diff).replace(".", ","), 4);//String(el.Diff).replace(".", ",");
                zstDiff = me.formatNumber(String(el.ZstDiff).replace(".", ","), 4);//String(el.ZstDiff).replace(".", ",");

                tableRow = vcListItem.clone().append(
                    vcListCol.clone().append(
                        vcListColElement.clone().addClass("signal text").prop("title", "ID: " + el.Id).html(el.Name + " " + "[" + el.Unit + "]"),
                        vcListColElement.clone().addClass("date date").html(el.Timestamp),
                        vcListColElement.clone().addClass("sum number").html(sum),
                        vcListColElement.clone().addClass("diff number").html(diff),
                        vcListColElement.clone().addClass("diffZst number").html(zstDiff)
                    )
                );
                if (i % 2 === 1) {
                    tableRow.addClass("alt");
                    
                }
                i++;
                table.append(tableRow);
            });

            me.visual.find("> .content .vc-list-table").html(table.html());
        });
    } catch (ex) { me.writeError('fillTable', ex); }
};

ZstValidation.prototype.filter = function () {
    /// <summary>
    /// This function filters the entries based on a given filter and filters the complete content of the list based on the vcFilter  <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        //hide all
        me.visual.find("> .content .vc-list .vc-list-table .vc-list-item").removeClass("found").data("counter", 0).hide();

        //we add the 'found' class to all items we want to filter based on the vcfilter tags
        me.setTagFilter(".vc-filter", "> .content .vc-list .vc-list-table .vc-list-item", "found");

        me.visual.find("> .content .vc-list .vc-list-table .vc-list-item.found").show();
        me.visual.find("> .content .vc-list .vc-list-table .vc-list-item").removeClass("alt");
        me.visual.find("> .content .vc-list .vc-list-table .vc-list-item.found:even").addClass("alt");

        return true;
    } catch (ex) { me.writeError('filter', ex); return false; }

};

ZstValidation.prototype.formatNumber = function (number, digits) {
    /// <summary>
    /// This function filters the entries based on a given filter and filters the complete content of the list based on the vcFilter  <br/>
    /// </summary>
    var me = this;
    var rgxNumberDisplayFormat = RegExp("[0-9]*\,[0-9]{" + digits + "}");
    var rgxIsCommaExistent = RegExp(".*\,.*");
    try {
        if (me.error) { return false; }
        var fraction = "";

        if (rgxIsCommaExistent.test(number)) {
            fraction = String(number).split(",")[1];
            number = String(number).split(",")[0];

            number = parseFloat(number).toLocaleString("de-DE");
            number = number + "," + fraction;

            while (!rgxNumberDisplayFormat.test(number)) {
                if (!rgxIsCommaExistent.test(number)) {
                    number += ",";
                }
                number += "0";
            }
            return number;
        }

        number = parseFloat(number).toLocaleString("de-DE");
        while (!rgxNumberDisplayFormat.test(number)) {
            if (!rgxIsCommaExistent.test(number)) {
                number += ",";
            }
            number += "0";
        }

        return number;
    } catch (ex) { me.writeError('filter', ex); return false; }

};
